import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import gql from 'graphql-tag';
import { useApolloClient } from '@apollo/client';
import { useCurrency, useI18n } from '~Hooks';
import Heading from '~ComponentsImproved/Typography/Heading';
import { Box } from '~Styles';

const Wrapper = styled.div`
  border-left: 3px solid var(--colorUIOrange);
`;

const Header = styled(Box)`
  background-color: var(--colorUIOrange);
  color: var(--colorBlueGray1300);
  padding: 4px 12px 4px 10px;

  h5:first-of-type {
    flex: 1;
  }
`;

const Strike = styled.span`
  color: var(--colorBlueGray1300);
  text-decoration: line-through;
  opacity: 0.5;
`;

const Price = styled.h5`
  font-size: 12px;
  min-width: 40px;
  box-sizing: border-box;
  text-align: right;
  margin: 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  color: var(--colorBlueGray1300);
  gap: 6px;
`;

interface Props {
  offerId: string;
  oldPrice?: number;
  newPrice?: number;
}
const OfferItemWrapper: React.FunctionComponent<Props> = ({
  offerId,
  children,
  oldPrice,
  newPrice,
}) => {
  const client = useApolloClient();
  const { i18n } = useI18n();
  const currency = useCurrency();

  const offer = useMemo(() => {
    return client.readFragment({
      id: offerId,
      fragment: gql`
        fragment offer on Offer {
          id
          nameLang {
            id
            se
            en
            es
            no
          }
        }
      `,
    });
  }, [offerId]);

  return (
    <Wrapper>
      <Header display="flex" gap="small" justifyContent="space-between" alignItems="center">
        <Heading level={5} color="var(--colorBlueGray1300)">
          {i18n(offer.nameLang)}
        </Heading>
        <Price>
          {oldPrice && oldPrice !== newPrice && <Strike>{currency.format(oldPrice)}</Strike>}
          {newPrice !== undefined ? `${currency.format(newPrice)}` : '-'}
        </Price>
      </Header>
      {children}
    </Wrapper>
  );
};

export default OfferItemWrapper;
